import React, { useState } from "react";
import { Box, Flex, Input, Text } from "@chakra-ui/react";
import { FaPlus } from "react-icons/fa";
import axios from "axios";
import { API_URL } from "../config";
import { getToken } from "../token";
import { FORUM, TRANSITION } from "../Theme/styles";
import AssigneePicker from "./AssigneePicker";

const AddAssignment = ({ taskId, people, boardCategory, onAdded }) => {
  const [open, setOpen] = useState(false);
  const [picked, setPicked] = useState([]);
  const [item, setItem] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const save = async () => {
    if (picked.length === 0 || saving) return;
    setSaving(true);
    setError(null);
    try {
      for (const a of picked) {
        await axios.post(
          `${API_URL}/tasks/${taskId}/assignments`,
          {
            team: a.team,
            assigned_to: a.assigned_to || null,
            items: item.trim() ? [{ description: item.trim() }] : [],
          },
          { withCredentials: true, headers: { Authorization: `Bearer ${getToken()}` } }
        );
      }
      setPicked([]);
      setItem("");
      setOpen(false);
      onAdded();
    } catch (e) {
      setError(e?.response?.data?.error || "Nie udało się przypisać.");
    } finally {
      setSaving(false);
    }
  };

  if (!open) {
    return (
      <Flex
        as={"button"}
        align={"center"}
        gap={2}
        mt={1}
        color={FORUM.tekstPrzygaszony}
        transition={TRANSITION}
        _hover={{ color: FORUM.tekstJasny }}
        onClick={() => setOpen(true)}
      >
        <FaPlus size={10} />
        <Text fontSize={"xs"}>Przypisz zespół albo osobę</Text>
      </Flex>
    );
  }

  return (
    <Box
      border={"1px solid"}
      borderColor={FORUM.obramowanie}
      bg={FORUM.tlo}
      borderRadius={"md"}
      p={3}
      mt={2}
    >
      <AssigneePicker
        people={people}
        assignments={picked}
        onChange={setPicked}
        categoryOfBoard={boardCategory}
      />

      <Input
        size={"sm"}
        mt={3}
        placeholder={"Co ma zrobić (opcjonalnie)"}
        value={item}
        onChange={(e) => setItem(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && save()}
      />

      {error && (
        <Text fontSize={"xs"} color={"#F08A80"} mt={2}>
          {error}
        </Text>
      )}

      <Flex gap={2} mt={3} justify={"flex-end"}>
        <Box
          as={"button"}
          fontSize={"sm"}
          px={3}
          py={1}
          borderRadius={"md"}
          bg={FORUM.przycisk}
          color={FORUM.tekst}
          onClick={() => {
            setOpen(false);
            setPicked([]);
          }}
        >
          Anuluj
        </Box>
        <Box
          as={"button"}
          fontSize={"sm"}
          px={3}
          py={1}
          borderRadius={"md"}
          bg={FORUM.granat}
          color={FORUM.tekstJasny}
          opacity={picked.length === 0 ? 0.5 : 1}
          onClick={save}
        >
          {saving ? "Zapisuję…" : "Przypisz"}
        </Box>
      </Flex>
    </Box>
  );
};

export default AddAssignment;
